var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BLACK_700, BLACK_900, BLACK_500, DynamicSvg, Typography, getTestId, isValidObject, useBreakpoint } from '@airtel/air-design-system';
import { useEffect, useRef, useState } from 'react';
import { Image, View, Animated } from 'react-native';
import { getSectionTitleWidgetStyles } from './SectionTitleWidgetStyles';
import { getTypographyType } from './SectionTitleWidgetUtils';
import { SectionTitleActions } from './components/section-title-actions';
import { SectionTitleTooltip } from './components/section-title-tool-tip';
export var SectionTitleWidgetComponent = props => {
  var _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'SectionTitleWidget' : _props$testID,
    style = props.style,
    color = props.color,
    iconName = props.iconName,
    _props$imageProps = props.imageProps,
    imageProps = _props$imageProps === void 0 ? {} : _props$imageProps,
    title = props.title,
    titleProps = props.titleProps,
    isTitleBold = props.isTitleBold,
    subtitle = props.subtitle,
    subtitleProps = props.subtitleProps,
    description = props.description,
    subtextProps = props.subtextProps,
    _props$showInfoIcon = props.showInfoIcon,
    showInfoIcon = _props$showInfoIcon === void 0 ? false : _props$showInfoIcon,
    showBulletSeparator = props.showBulletSeparator,
    children = props.children,
    onUserAction = props.onUserAction,
    _props$isDisabled = props.isDisabled,
    isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled,
    animatedTitle = props.animatedTitle,
    _props$animationDelay = props.animationDelay,
    animationDelay = _props$animationDelay === void 0 ? 1000 : _props$animationDelay,
    _props$iconSize = props.iconSize,
    iconSize = _props$iconSize === void 0 ? 24 : _props$iconSize,
    titleColor = props.titleColor,
    descriptionColor = props.descriptionColor,
    _props$accessible = props.accessible,
    accessible = _props$accessible === void 0 ? true : _props$accessible,
    restProps = __rest(props, ["testID", "style", "color", "iconName", "imageProps", "title", "titleProps", "isTitleBold", "subtitle", "subtitleProps", "description", "subtextProps", "showInfoIcon", "showBulletSeparator", "children", "onUserAction", "isDisabled", "animatedTitle", "animationDelay", "iconSize", "titleColor", "descriptionColor", "accessible"]);
  var sectionTitleWidgetStyles = getSectionTitleWidgetStyles();
  var fadeOutAnim = useRef(new Animated.Value(1)).current;
  var _useState = useState(title),
    sectionTitle = _useState[0],
    setSectionTitle = _useState[1];
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isSmallScreen = _useBreakpoint.isSmallScreen;
  useEffect(() => {
    if (animatedTitle) {
      Animated.timing(fadeOutAnim, {
        toValue: 0,
        duration: animationDelay || 1000,
        useNativeDriver: true
      }).start(() => {
        setSectionTitle(animatedTitle);
        Animated.timing(fadeOutAnim, {
          toValue: 1,
          duration: animationDelay || 1000,
          useNativeDriver: true
        }).start();
      });
    }
  }, [animatedTitle]);
  return _jsxs(_Fragment, {
    children: [_jsxs(View, Object.assign({
      style: [sectionTitleWidgetStyles.container, style]
    }, restProps, getTestId(testID), {
      accessible: accessible
    }, {
      children: [_jsx(View, Object.assign({
        style: sectionTitleWidgetStyles.iconImgContainer
      }, {
        children: iconName ? _jsx(DynamicSvg, Object.assign({
          iconName: iconName,
          style: sectionTitleWidgetStyles.iconImg,
          fontSize: iconSize,
          color: color
        }, getTestId(testID, iconName))) : isValidObject(imageProps) && _jsx(Image, Object.assign({
          source: imageProps,
          style: sectionTitleWidgetStyles.iconImg
        }, getTestId(testID, 'image')))
      })), _jsxs(View, Object.assign({
        style: sectionTitleWidgetStyles.content
      }, {
        children: [(!!title || !!subtitle || showInfoIcon) && _jsxs(View, Object.assign({
          style: [sectionTitleWidgetStyles.titleContainer, description && sectionTitleWidgetStyles.titleContainerMargin]
        }, {
          children: [_jsx(Animated.View, Object.assign({
            style: {
              opacity: fadeOutAnim
            }
          }, {
            children: !!title && _jsx(Typography, Object.assign({
              style: sectionTitleWidgetStyles.title,
              text: sectionTitle,
              color: isDisabled ? BLACK_500 : isTitleBold ? BLACK_900 : BLACK_700,
              isBold: isTitleBold,
              numberOfLines: 1,
              noTextTransform: true,
              type: getTypographyType('title', isTitleBold, isSmallScreen)
            }, getTestId(testID, 'title'), !!titleColor && {
              color: titleColor
            }, titleProps))
          })), !!subtitle && _jsx(Typography, Object.assign({
            text: title ? (showBulletSeparator ? '•' : '') + " " + subtitle : subtitle,
            color: isDisabled ? BLACK_500 : BLACK_700,
            type: getTypographyType('subtitle', false, isSmallScreen),
            numberOfLines: 1
          }, getTestId(testID, 'subtitle'), subtitleProps)), showInfoIcon && _jsx(SectionTitleTooltip, Object.assign({}, props))]
        })), isValidObject(subtextProps) && _jsx(View, Object.assign({}, restProps, {
          accessible: true
        }, {
          children: _jsx(Typography, Object.assign({
            color: BLACK_900,
            type: getTypographyType('subtext', false, isSmallScreen),
            numberOfLines: 1
          }, getTestId(testID, 'subtext'), !!subtextProps && subtextProps))
        })), !!description && _jsx(View, Object.assign({}, restProps, {
          accessible: true
        }, {
          children: _jsx(Typography, Object.assign({
            text: description,
            color: isDisabled ? BLACK_500 : BLACK_700,
            type: getTypographyType('description', false, isSmallScreen),
            numberOfLines: 3
          }, getTestId(testID, 'description'), !!descriptionColor && {
            color: descriptionColor
          }))
        }))]
      })), _jsx(SectionTitleActions, Object.assign({}, props, {
        onUserAction: onUserAction
      }))]
    })), children]
  });
};
SectionTitleWidgetComponent.genericRendererKey = 'AirSectionTitleWidget';